// tms/my-model
import {
  getData,
} from 'src/services/RestApi';
import { formatDate, currentSeconds } from 'src/utils/date-locale';
import { formatDecimal } from 'src/utils/formatters';
import { dayColor } from 'src/utils/color-rules';
import { setCacheCheckin, getCacheCheckin } from 'src/utils/cache-data';

export const getList = async (
  payload, {},
  onEndPoint = () => {},
  onSuccess = () => {},
  onError = () => {},
) => {
  const endPoint = 'api/tms/list';
  onEndPoint(endPoint);

  const { result, error } = await getData(endPoint, payload);
  if (error) {
    return onError(error);
  }

  const seconds = currentSeconds();

  result.forEach((element) => {
    if(element.checkOut > 0)
      element.distance = formatDecimal(element.checkoutKm - element.checkinKm);
    element.checkIn = formatDate(element.checkIn, 'dd/MM/yy - HH:mm');
    element.checkOut = formatDate(element.checkOut, 'dd/MM/yy - HH:mm');
    element.checkinBy = formatDate(element.checkinBy, 'HH:mm');
    element.checkoutBy = formatDate(element.checkoutBy, 'HH:mm');
    element.dayColor = dayColor(element.createdAt, seconds);
  });
  return onSuccess(result);
};

export const getMyList = async (
  payload, {},
  onEndPoint = () => {},
  onSuccess = () => {},
  onError = () => {},
) => {
  const endPoint = 'api/tms/my-list';
  onEndPoint(endPoint);

  const { result, error } = await getData(endPoint, payload);
  if (error) return onError(error);

  if (result) {
    result.forEach((element) => {
      const tempCheckin = element.checkinBy || element.checkIn;
      element.checkDay = formatDate(tempCheckin, 'dd/MM/yy');
      element.checkIn = formatDate(tempCheckin, 'HH:mm');
      if (element.checkOut) {
        const tempCheckout = element.checkoutBy || element.checkOut;
        element.checkOut = formatDate(tempCheckout, 'HH:mm');
        element.trips = formatDecimal(element.checkoutKm - element.checkinKm);
      } else {
        element.checkOut = '';
        element.trips = '';
      }
      
    });
  }
  return onSuccess(result);
};

export const getCheckinStatus = async () => {
  // Get data from caching, maybe using current time for refresh
  const cache = getCacheCheckin();
  if (cache && cache.id > 0) {
    const milliseconds = new Date().getTime();
    const expired = cache.expired || 0;
    if (expired > milliseconds) {
      return cache;
    }
  }
  
  const { result, error } = await getData('api/tms/checkin/status');
  if(error) return {};

  if (result) {
    // Save data to cache
    setCacheCheckin({ tms: result });
  }
  return result;
};

export const getItemById = async (payload) => {
  const tmsId = Number(payload?.id) || 0;
  if (tmsId === 0) return {};

  let { result, error } = await getData('api/tms/detail', { tmsId });
  if(error) return {};
  
  result.checkinSys = formatDate(result.checkIn, 'dd/MM/yy - HH:mm');
  result.checkoutSys = formatDate(result.checkOut, 'dd/MM/yy - HH:mm');

  return result;
};
